import { PromoStore } from '@/mainComponent/store/PromoStore';
import { ShowStartPromo } from '@/mainComponent/items/otherActions/ShowStartPromo';
import { FreeSpinsTournamentController } from '@/mainComponent/items/tournaments/FreeSpinsTournamentController';
import { PopupsFreeSpinsController } from '@/mainComponent/items/achievements/PopupsFreeSpinsController';
import { PromoElementsController } from '@/mainComponent/items/otherActions/PromoElementsController';
import { SetAchievementData } from '@/mainComponent/items/achievements/SetAchievementData';
import { SetFreeSpinsData } from '@/mainComponent/items/tournaments/SetFreeSpinsData';
import { SetPromoAppConfig } from '@/mainComponent/items/otherActions/SetPromoAppConfig';
import { SetTournamentData } from '@/mainComponent/items/tournaments/SetTournamentData';
import { ToolTipController } from '@/mainComponent/items/otherActions/ToolTipController';
import { TimerController } from '@/mainComponent/items/otherActions/TimerController';
import { PopupAchievementCounterController } from '@/mainComponent/items/achievements/PopupAchievementCounterController';
import { PopupFreeRoundsController } from '@/mainComponent/items/freeRounds/PopupFreeRoundsController';
import { SetFreeRoundsData } from '@/mainComponent/items/freeRounds/SetFreeRoundsData';
import { PopupAchievementPrizeGameController } from '@/mainComponent/items/achievements/PopupAchievementPrizeGameController';
import { FinishedPrizeGame } from '@/mainComponent/items/achievements/FinishedPrizeGame';
import { BaseComponent } from '@/mainComponent/items/BaseComponent';
import { IAchievement } from '@/mainComponent/store/interfaces/IAchievement';
import { BetController } from '@/mainComponent/items/gameUIControllers/BetController';
import { SpinController } from '@/mainComponent/items/gameUIControllers/SpinController';
import { IPayment } from '@/mainComponent/store/interfaces/newInterfaces/IPayment';
import { ACTION } from '@/store/ACTION';

class PromoComponent extends BaseComponent {
  protected isOpenSystemPopup: boolean = false;
  protected onceSetPromoAppHandlers: boolean = false;

  static events = {
    START_ACHIEVEMENT: 'PromoComponent.START_ACHIEVEMENT',
    END_ACHIEVEMENT: 'PromoComponent.END_ACHIEVEMENT',
    START_FREESPINS: 'PromoComponent.START_FREESPINS',
    START_FREESPINS_OTHER_GAME: 'START_FREESPINS_OTHER_GAME',
    FINISHED_TOURNAMENT: 'FINISHED_TOURNAMENT',
    START_TOURNAMENT: 'START_TOURNAMENT',
    RECEIVE_FIRST_DATA: 'RECEIVE_FIRST_DATA',
    MAIN_FLOW_EXECUTE: 'MAIN_FLOW_EXECUTE',
    SET_WAGER: 'SET_WAGER'
  };

  static src = {
    ShowStartPromo: ShowStartPromo,
    FreeSpinsTournamentController: FreeSpinsTournamentController,
    PopupsFreeSpinsController: PopupsFreeSpinsController,
    PromoElementsController: PromoElementsController,
    SetAchievementData: SetAchievementData,
    SetFreeSpinsData: SetFreeSpinsData,
    SetPromoAppConfig: SetPromoAppConfig,
    SetTournamentData: SetTournamentData,
    ToolTipController: ToolTipController,
    TimerController: TimerController,
    PopupAchievementCounterController: PopupAchievementCounterController,
    PopupFreeRoundsController: PopupFreeRoundsController,
    SetFreeRoundsData: SetFreeRoundsData,
    PopupAchievementPrizeGameController: PopupAchievementPrizeGameController,
    FinishedPrizeGame: FinishedPrizeGame
  };

  showStartPromo: ShowStartPromo;

  freeSpinsTournamentController: FreeSpinsTournamentController;
  popupsFreeSpinsController: PopupsFreeSpinsController;
  promoElementsController: PromoElementsController;
  setAchievementData: SetAchievementData;
  setFreeSpinsData: SetFreeSpinsData;
  setPromoAppConfig: SetPromoAppConfig;
  setTournamentData: SetTournamentData;
  toolTipController: ToolTipController;
  timerController: TimerController;
  popupAchievementCounterController: PopupAchievementCounterController;
  popupFreeRoundsController: PopupFreeRoundsController;
  setFreeRoundsData: SetFreeRoundsData;
  popupAchievementPrizeGameController: PopupAchievementPrizeGameController;
  finishedPrizeGame: FinishedPrizeGame;
  betController: BetController;
  spinController: SpinController;
  init(): void {
    super.init();
    // @ts-ignore
    const lostData: any[] = this.store.promo.lostData;
    // @ts-ignore
    this.store.promo = new PromoStore();
    this.initActions();
    this.setHandlers();
    lostData.forEach(data => this.store.promo.setData(data));
  }

  onChangeOrientation() {
    if (!this.isOpenSystemPopup) return;
    if (this.isLandscape) {
      this.changeSystemPopupStatusHandler(false);
    } else {
      this.changeSystemPopupStatusHandler(this.isOpenSystemPopup);
    }
  }

  protected setHandlers(): void {
    game.on(PromoComponent.events.MAIN_FLOW_EXECUTE, this.mainExecutions.bind(this));
    game.on('game.render.ON_CHANGE_ORIENTATION', this.onChangeOrientation, this);
    game.on(PromoStore.events.SET_TOURNAMENT_DATA, () => {
      this.setTournamentData.execution();
    });

    game.on('game.fsm.CHANGE_STATE', (data: any) => {
      if (data.state === 'IDLE' &&
          (data.prevGameMode === 'bonus' || data.prevGameMode === 'freespins') &&
          data.gameMode === 'main') {
        const updatePromoElements  = this.promoElementsController.systemPopupController.bind(this.promoElementsController);
        updatePromoElements({ status: 0 })
      }
    });

    game.on(PromoStore.events.SET_ACHIEVEMENT_COUNTER, () => {
      this.setAchievementData.execution();
    });

    game.on('UIComponent.CHANGE_MENU_STATUS', ({ status }: { status: boolean }) => {
      if (status) {
        this.promoElementsController.hidePromoElements();
        return;
      }
      // case then we have freeRounds For Api and active promo. We have not show panel icon, but show
      this.promoElementsController.showProgressBar();
      if (this.store.promo.isStartPromo) this.promoElementsController.showPanelIcon();
    });

    game.on(
      'AutoplayComponent.CHANGE_STATUS_POPUP',
      this.promoElementsController.systemPopupController.bind(this.promoElementsController)
    );
    game.on(
      'BET.BET_POPUP_CHANGE_STATUS',
      this.promoElementsController.systemPopupController.bind(this.promoElementsController)
    );

    // GPLAT-91 decided not to hide the promo elements on errors
    // game.on(
    //   'CHANGE_VISIBLE_ERROR_POPUP',
    //   this.promoElementsController.systemPopupController.bind(this.promoElementsController)
    // );

    game.on('BUY_FEATURE.BUY_FEATURE_POPUP_CHANGE_STATUS', ({ status }: { status: boolean }) => {
      this.isOpenSystemPopup = status;
      if (!this.isLandscape) {
        this.changeSystemPopupStatusHandler(status);
      }
    });
    game.on(PromoComponent.events.START_FREESPINS, () => {
      game.component.autoplay.onTurnOffAutoplay();
      game.component.bet.currentBet = this.store.promo.betFreeSpinGame;
      this.updateUI();
    });
    game.on(PromoComponent.events.START_ACHIEVEMENT, this.updateUI.bind(this));
    game.on(PromoComponent.events.FINISHED_TOURNAMENT, this.updateUI.bind(this));
    game.on(PromoComponent.events.START_TOURNAMENT, this.updateUI.bind(this));
    game.on(PromoComponent.events.END_ACHIEVEMENT, () => {
      this.updateUI();
      this.removingWager();
    });
    game.on(PromoComponent.events.START_FREESPINS_OTHER_GAME, () => {
      this.updateUI();
      game.component.autoplay.onTurnOffAutoplay();
    });
    game.on('game.network.ON_SOCKET_MESSAGE', (data: any) => {
      if (data.command === 'collect') this.mainExecutions();
    });
    game.on('game.network.ON_SOCKET_MESSAGE', (data: any) => {
      if (data.command === 'tournament' && data.players) {
        game.store.promo.tournamentPlayers = data.players;
        promoApp.eventEmitter.emit(ACTION.SET_TOURNAMENT_PLAYERS_DATA, data);
      }
    });
    document.addEventListener('promoLoaded', this.onPromoLoaded.bind(this));
    promoApp.eventEmitter.on('SHOW_PRIZE_GAME_WIN', this.setPromoPrize.bind(this));
    promoApp.eventEmitter.on('SHOW_FREESPIN_WIN', this.setPromoPrize.bind(this));
    game.on(PromoComponent.events.SET_WAGER, this.setPromoPrize.bind(this));
    game.on(PromoComponent.events.RECEIVE_FIRST_DATA, () => {
      this.mainExecutions();
      this.showStartPromo.execution();
    });
  }

  getWagerConfig() {
    let id: string = '';
    if (
      (!id && this.store.promo.isAchievement) ||
      this.store.promo.isAchievementBG ||
      this.store.promo.isAchievementFS
    ) {
      id = (<IAchievement>this.store.promo.activeAchievement).reward.id;
      this.store.promo.wagerType = 'achievement';
    }

    if (!id && this.store.promo.isFreeSpinsTournament) {
      id = <string>this.store.promo.tournamentFreeSpin?.id;
      this.store.promo.wagerType = 'tournament';
    }

    return {
      type: 'wager',
      id
    };
  }

  removingWager() {
    switch (this.store.promo.wagerType) {
      case 'api':
        if (this.store.promo.freeRounds?.roundsLeft ?? 0 > 0) return;
        break;
      case 'achievement':
        if (
          this.store.promo.activeAchievement &&
          (<IAchievement>this.store.promo.activeAchievement).reward.roundsLeft > 0
        )
          return;
        break;
      case 'tournament':
        if (this.store.promo.tournamentFreeSpin && this.store.promo.tournamentFreeSpin.reward.roundsLeft > 0) return;
        if (this.store.promo.wagerData && (<IPayment>this.store.promo.wagerData).roundsLeft > 0) return;
        break;
    }

    game.store.removeServerMode('wager');
    this.store.promo.wagerType = '';
    this.store.promo.wagerData = null;
  }

  setPromoPrize(data: { type: string; id: string } | undefined) {
    const config = data ? { id: data.id, type: 'wager' } : this.getWagerConfig();
    if (data) this.store.promo.wagerType = data.type;
    if (game.store.getServerMode(config.type).mode || !config.id) return;
    game.store.applyServerMode(config);
  }

  onPromoLoaded(): void {
    this.mainExecutions();
    this.setPromoAppConfig.execution(game.component.promo.options.config);
    this.store.promo.isStartGameForPromo = true;
    this.freeSpinsTournamentController.execution();
    this.showStartPromo.execution();
  }

  private updateUI(): void {
    this.spinController.update();
    this.betController.updateBets();
    game.component.buyFeature?.onChangeOrientation();
    game.component.hotBet?.onChangeOrientation();
  }

  protected changeSystemPopupStatusHandler(status: boolean): void {
    if (!game.env.isMobileDevice()) return;

    if (status) {
      this.promoElementsController.hidePromoElements();
      return;
    }
    this.promoElementsController.showPromoElements();
  }

  protected initActions() {
    this.showStartPromo = new PromoComponent.src.ShowStartPromo();
    this.freeSpinsTournamentController = new PromoComponent.src.FreeSpinsTournamentController();
    this.popupsFreeSpinsController = new PromoComponent.src.PopupsFreeSpinsController();
    this.promoElementsController = new PromoComponent.src.PromoElementsController();
    this.setAchievementData = new PromoComponent.src.SetAchievementData();
    this.setFreeSpinsData = new PromoComponent.src.SetFreeSpinsData();
    this.setPromoAppConfig = new PromoComponent.src.SetPromoAppConfig();
    this.setTournamentData = new PromoComponent.src.SetTournamentData();
    this.toolTipController = new PromoComponent.src.ToolTipController();
    this.timerController = new PromoComponent.src.TimerController();
    this.popupAchievementCounterController = new PromoComponent.src.PopupAchievementCounterController();
    this.popupFreeRoundsController = new PromoComponent.src.PopupFreeRoundsController();
    this.setFreeRoundsData = new PromoComponent.src.SetFreeRoundsData();
    this.popupAchievementPrizeGameController = new PromoComponent.src.PopupAchievementPrizeGameController();
    this.finishedPrizeGame = new PromoComponent.src.FinishedPrizeGame();
    this.betController = new BetController();
    this.spinController = new SpinController();
  }

  private Utils: { isNumber: (value: any) => boolean; isLocalProject: () => boolean } = {
    isNumber: (value: number | string) => {
      return !isNaN(Number(value));
    },
    isLocalProject: () => {
      return this.Utils.isNumber(document.location.host[0]) || document.location.host.includes('localhost');
    }
  };

  async waitSpinOnce() {
    if (this.store.promo.isStartPromo) return;
    this.store.promo.isStartGameForPromo = true;
    this.freeSpinsTournamentController.execution();
    this.showStartPromo.execution();
  }

  async waitSpin() {
    this.waitSpinOnce();
    this.finishedPrizeGame.execution();
  }

  async onSpinEnterSpin() {
    this.toolTipController.saveTotalBet();
  }

  protected setPromoAppHandlers(): void {
    if (!this.store.promo.hasPromoApp() || this.onceSetPromoAppHandlers) return;

    this.setPromoAppConfig.execution(game.component.promo.options.config);
    promoApp.eventEmitter.on('REQUIRE_TOURNAMENT_PLAYERS', () => {
      game.emit('NetworkComponent.REQUIRE_TOURNAMENT_PLAYERS');
    });
    this.onceSetPromoAppHandlers = true;
  }

  async onSpinEndSpin() {
    this.toolTipController.execution();
  }

  async onIdleEnter() {
    this.removingWager();
    this.mainExecutions();
  }

  mainExecutions(): void {
    this.setPromoAppHandlers();
    this.setAchievementData.execution();
    this.setTournamentData.execution();
    this.setFreeRoundsData.execution();
    this.timerController.startPromo();
    this.popupsFreeSpinsController.execution();
    this.popupAchievementPrizeGameController.execution();
    this.setFreeSpinsData.execution();
    this.freeSpinsTournamentController.execution();
    this.popupAchievementCounterController.execution();
    this.popupFreeRoundsController.execution();
  }

  get isLandscape(): boolean {
    return game.render.isLandscapeMode;
  }
}

export { PromoComponent };
